
export const vuexConverter = namespace => {
  return {
    mapAction: action => {
      return `${namespace}/${action}`
    },
    mapGetter: getter => {
      return `${namespace}/${getter}`
    },
    mapMutation: mutation => {
      return `${namespace}/${mutation}`
    },
  }
}
